<template>
    <tr :class="`${isDeleteRequested || isEditRequested || isViewRequested ? 'edit-row' : ''}`">
        <td>{{ note.title }}</td>
        <td>{{ formatDate(note.date) }}</td>
        <td>{{ note.userName }}</td>
        <td class="text-end" v-if="!isDeleteRequested">
            <template v-if="note.isCreatedUser">
                <button
                    type="button"
                    class="btn table-btn btn-outline-danger"
                    v-if="!isEditRequested"
                    v-tooltip="{ title: 'Delete Note' }"
                >
                    <i class="fas fa-trash-alt"></i>
                </button>
            </template>
        </td>
        <td colspan="1" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteNote"
                :cancel="cancelDeleteNote"
            />
        </td>
    </tr>
</template>

<script lang="ts" src="./PreadmissionNotesRow.ts"></script>
